import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import NavBar from "../navbar/NavBar";
import Footer from "../footer/Footer";
import "./chinaMarathonDetailsStyle.css";
import { chinaMarathons } from "../../data/chinaMarathon";
import CAALogo from "../../assets/icons/CAA-logo.png";
import {
  FaCalendarAlt,
  FaHotel,
  FaUtensils,
  FaBinoculars,
} from "react-icons/fa";

const ChinaMarathonDetails = () => {
  const { cityName, marathonName } = useParams();
  const [marathons, setMarathons] = useState([]);
  const isMountedRef = useRef(true);
  const [activeTravelDay, setActiveTravelDay] = useState(1);

  useEffect(() => {
    // 标记组件已挂载
    isMountedRef.current = true;

    // 查找匹配的马拉松数据
    try {
      const cityMarathons = chinaMarathons[cityName] || [];
      const foundMarathon = cityMarathons.find(
        (marathon) => marathon.id === marathonName
      );

      // 如果找到了马拉松数据(对象)，设置状态
      if (foundMarathon && isMountedRef.current) {
        setMarathons(foundMarathon);
      }
    } catch (error) {
      console.error("查找马拉松数据出错:", error);
    }

    // 组件卸载时清理
    return () => {
      isMountedRef.current = false;
    };
  }, [cityName, marathonName]);

  return (
    <div className="marathon-details">
      <NavBar />
      {/* 马拉松大标题 */}
      <div className="marathon-detail-container">
        <h1 className="marathon-name">{marathons.name}</h1>
      </div>

      <div className="marathon-info-container">
        <div className="marathon-image-details">
          {marathons.image && (
            <img src={marathons.image} alt={marathons.name || "马拉松图片"} />
          )}
        </div>

        <div className="marathon-info-details">
          <div className="marathon-info-item">
            <h3>比赛时间</h3>
            <p>{marathons.date}</p>
          </div>
          <div className="marathon-info-item">
            <h3>比赛距离</h3>
            <p>{marathons.distance}</p>
          </div>
          <div className="marathon-info-item">
            <h3>参赛人数</h3>
            <p>{marathons.numberOfParticipants}</p>
          </div>
          {marathons.isCAAcertified && (
            <div className="marathon-info-item caa-certified">
              <h3>赛事认证</h3>
              <div className="certification-row">
                <img src={CAALogo} alt="中国田协认证" className="caa-logo" />
                <div>
                  {marathons.grade && (
                    <div className="grade-info">
                      {marathons.gradeImage && (
                        <img
                          src={marathons.gradeImage}
                          alt={`${marathons.grade}级赛事`}
                          className="grade-logo"
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="map-container marathon-detail-container">
        <div className="route-features-container">
          {marathons.routeImage ? (
            <div className="route-map">
              <h2>赛事路线</h2>

              <img
                src={marathons.routeImage}
                alt={`${marathons.name}赛道路线`}
                className="route-image"
                onClick={(e) => {
                  // 点击图片时打开大图
                  window.open(marathons.routeImage, "_blank");
                }}
                style={{
                  cursor: "pointer",
                  maxWidth: "100%",
                  maxHeight: marathons.id.includes("haidian-marathon")
                    ? "400px"
                    : "450px",
                  width: "auto",
                }}
              />

              <p className="route-note">
                *路线图仅供参考，具体赛道以官方发布为准 (点击图片可查看大图)
              </p>
            </div>
          ) : (
            // 如果 routeImage 不存在，显示提示信息
            <div className="marathon-detail-container no-route-info">
              <h2>赛事路线</h2>
              <p>暂无路线图，请关注官方媒体获取最新信息。</p>
            </div>
          )}
          {/* Features Section */}
          <div className="features-section">
            <h3>赛事特色</h3>
            {marathons.features ? (
              <div className="features-list">
                {marathons.features.map((feature) => (
                  <div key={feature.id} className="feature-item">
                    <h4 className="feature-name">{feature.name}: </h4>
                    <div className="feature-content">
                      <h4>{feature.content}</h4>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-features">暂无赛事特色信息</p>
            )}
          </div>
        </div>
      </div>

      {/* 旅行计划区域 - Tab 结构 */}
      {marathons.travelPlan && (
        <div className="travel-plan-container marathon-detail-container">
          <h2>{marathons.travelPlan.title || "跑游攻略"}</h2>
          <p className="travel-plan-description">
            {marathons.travelPlan.description}
          </p>

          {/* Tab 按钮 */}
          <div className="travel-plan-tabs">
            {marathons.travelPlan.days.map((dayPlan) => (
              <button
                key={dayPlan.day}
                className={`tab-button ${
                  activeTravelDay === dayPlan.day ? "active" : ""
                }`}
                onClick={() => setActiveTravelDay(dayPlan.day)}
              >
                第 {dayPlan.day} 天
              </button>
            ))}
          </div>

          {/* Tab 内容区域 */}
          <div className="travel-plan-content">
            {marathons.travelPlan.days.map(
              (dayPlan) =>
                // 只渲染当前激活的天的内容
                activeTravelDay === dayPlan.day && (
                  <div
                    key={dayPlan.day}
                    className="travel-plan-day-content active"
                  >
                    {" "}
                    {/* 使用新的类名 */}
                    <h3>{dayPlan.theme}</h3> {/* 将主题放到内容区域 */}
                    <div className="day-content">
                      {" "}
                      {/* 复用之前的网格布局 */}
                      <div className="day-section activities-section">
                        <h4>
                          <FaCalendarAlt className="section-icon" /> 行程安排
                        </h4>
                        <ul>
                          {dayPlan.activities.map((activity, actIndex) => (
                            <li key={actIndex}>
                              <strong>{activity.time}:</strong>{" "}
                              {activity.activity}
                              {activity.notes && (
                                <span className="activity-notes">
                                  {" "}
                                  ({activity.notes})
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="day-section recommendations-section">
                        <div className="recommendation-block">
                          <h4>
                            <FaHotel className="section-icon" /> 酒店推荐
                          </h4>
                          <ul>
                            {dayPlan.hotelRecommendations.map(
                              (hotel, hIndex) => (
                                <li key={hIndex}>{hotel}</li>
                              )
                            )}
                          </ul>
                        </div>
                        <div className="recommendation-block">
                          <h4>
                            <FaUtensils className="section-icon" /> 餐厅推荐
                          </h4>
                          <ul>
                            {dayPlan.restaurantRecommendations.map(
                              (resto, rIndex) => (
                                <li key={rIndex}>{resto}</li>
                              )
                            )}
                          </ul>
                        </div>
                        <div className="recommendation-block">
                          <h4>
                            <FaBinoculars className="section-icon" /> 景点推荐
                          </h4>
                          <ul>
                            {dayPlan.sightseeingRecommendations.map(
                              (sight, sIndex) => (
                                <li key={sIndex}>{sight}</li>
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )
            )}
          </div>
        </div>
      )}

      <div className="action-buttons">
        {marathons.web ? (
          <a
            href={marathons.web}
            target="_blank"
            rel="noopener noreferrer"
            className="registration-button"
          >
            立即报名
          </a>
        ) : (
          <p className="registration-button disabled">
            暂无官网链接,请关注赛事官方社交媒体获取最新信息
          </p>
        )}
      </div>
      <Footer />
    </div>
  );
};
export default ChinaMarathonDetails;
